import { render, staticRenderFns } from "./MindsetList.vue?vue&type=template&id=cfd960fe&scoped=true&"
import script from "./MindsetList.vue?vue&type=script&lang=js&"
export * from "./MindsetList.vue?vue&type=script&lang=js&"
import style0 from "./MindsetList.vue?vue&type=style&index=0&id=cfd960fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd960fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
